<!-- pricing component -->
<script>
  import { Col, Row, Container } from "sveltestrap";

  export let pricingData = {};
  const { title, description, pricing_list, footer_note } = pricingData;
</script>

<!--START PRICING-->
<section class="section pt-5 common-section" id="pricing">
  <Container>
    <Row>
      <Col lg={{ size: 8, offset: 2 }}>
        <h1 class="section-title text-center">{title}</h1>
        <div class="section-title-border mt-3" />
        <p class="section-subtitle font-secondary text-muted text-center pt-4">
          {description}
        </p>
        <div class="text-center mx-auto">
          <a href="mailto:Info@allaxishomeinspections.com" class="btn btn-primary waves-light waves-effect mt-5"
            >Email us for a free quote<i class="mdi mdi-arrow-right" /></a>
        </div>            
        <p class="section-subtitle font-secondary text-muted text-center pt-4">
          Please include name, contact info, and address of inspection.
        </p>
        <p class="text-center  contact-title text-muted">
          You can also call or text us for a free quote: <a href="tel:551-278-8200" target="_system">(551)278-8200</a>
       </p>               
      </Col>
    </Row>
    <Row>
      {#each pricing_list as list}
        <Col lg={{ size: 8, offset: 2 }}>
          <div class="text-center pricing-box hover-effect">
            <h4 class="text-uppercase">{list.title}</h4>
            <h6 class="text-uppercase text-muted">{list.subtitle}</h6>
            <div class="pricing-border" />
            <div class="plan-features mt-4">
              {#each list.size_price as item}
              <p>{item.squarefootage}: <b class="text-primary">{item.starting_price}</b></p>
              {/each}              
            </div>
            <h6 class="text-uppercase text-muted">{list.footer_note}</h6>            
          </div>
        </Col>
      {/each}
    </Row>
    <Row>
      <Col lg={{ size: 8, offset: 2 }}>
        <p class="section-subtitle font-secondary text-center pt-4">
          {footer_note}
        </p>
      </Col>
    </Row>    
  </Container>
</section>
<!--ENd PRICING-->
